export default "__VITE_ASSET__x4uwran4__"